<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="客户名称">
          <el-input v-model.trim="queryForm.customerName" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号：">
          <el-input v-model.trim="queryForm.customerPhone"></el-input>
        </el-form-item>
        <el-form-item label="车牌号：">
          <el-input v-model.trim="queryForm.carNumber"></el-input>
        </el-form-item>
        <el-form-item label="车架号：">
          <el-input v-model.trim="queryForm.VIN"></el-input>
        </el-form-item>
        <el-form-item label="质保单号:">
          <el-input v-model.trim="queryForm.code"></el-input>
        </el-form-item>
        <el-form-item label="膜卷号:">
          <el-input v-model.trim="queryForm.rollNumber"></el-input>
        </el-form-item>

        <el-form-item label="门店：">
          <el-select
            v-model="queryForm.storeId"
            filterable
            clearable
            remote
            :remote-method="getStoreList"
            placeholder="--选择门店--"
          >
            <el-option
              v-for="item in storeDataList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经销商：" prop="partnerId">
          <el-select
            v-model="queryForm.partnerId"
            filterable
            clearable
            remote
            :remote-method="getPartnerList"
            placeholder="--选择经销商--"
          >
            <el-option
              v-for="item in partnerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="技师：" prop="mechanicId">
          <el-select
            v-model="queryForm.mechanicId"
            clearable
            placeholder="--选择技师--"
          >
            <el-option
              v-for="item in mechanicList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-select
            v-model="queryForm.status"
            clearable
            placeholder="--选择状态--"
          >
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间：" prop="startAt">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="queryForm.startAt"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间：" prop="endAt">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="queryForm.endAt"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button type="primary" @click="getTableData()" :loading="eTabelLoading">导出表格</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <!-- :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)" -->
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" key="id" label="编号"></el-table-column>
          <el-table-column
            prop="code"
            key="code"
            label="质保单号"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="customerName"
            key="customerName"
            label="客户名称"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="customerPhone"
            key="customerPhone"
            label="手机号"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="productName"
            key="productName"
            label="产品类型"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="price"
            key="price"
            label="价格"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="carNumber"
            key="carNumber"
            label="车牌号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="VIN"
            key="VIN"
            label="车架号"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="carColor"
            key="carColor"
            label="汽车颜色"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="carName"
            key="carName"
            label="汽车型号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="storeName"
            key="storeName"
            label="门店名称"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="partnerName"
            key="partnerName"
            label="经销商"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="buildAt"
            key="buildAt"
            label="施工时间"
            width="120"
          ></el-table-column>
          <el-table-column prop="status" key="status" label="状态" width="120">
            <template slot-scope="scope">
              {{
                scope.row.status == 1
                  ? "待审核"
                  : scope.row.status == 2
                  ? "已审核"
                  : scope.row.status == 3
                  ? "已质保"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
            width="150"
          ></el-table-column>
          <el-table-column fixed="right" width="150" key="todo" label="操作">
            <template slot-scope="scope">
              <div style="margin-bottom: 10px">
                <el-button
                  @click="sh(scope.$index, scope.row)"
                  size="small"
                  :disabled="scope.row.status !== 1"
                  >审核</el-button
                >
                <!-- <el-button @click="zb(scope.$index, scope.row)" size="small" :disabled="scope.row.status === 3"
                  >质保</el-button
                > -->

                <span @click="bj(scope.$index, scope.row)" size="small"
                  >编辑</span
                >
                <span @click="sc(scope.$index, scope.row)" size="small"
                  >删除</span
                >
              </div>
              <!-- <span @click="xz(scope.$index,scope.row)" class="btns">下载</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :current-page="currentPage"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改质保客户"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="客户名称：" prop="customerName">
          <el-input
            v-model.trim="editForm.customerName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="customerPhone">
          <el-input
            v-model.trim="editForm.customerPhone"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="价格：" prop="price">
          <el-input
            type="number"
            v-model.trim="editForm.price"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="车牌号：" prop="carNumber">
          <el-input
            v-model.trim="editForm.carNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item
            label="车架号："
            prop="VIN"
            style="float: left; width: 50%"
          >
            <el-input
              v-model.trim="editForm.VIN"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="汽车颜色："
            prop="carColor"
            style="float: left; width: 50%"
          >
            <el-input
              v-model.trim="editForm.carColor"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item
            label="汽车型号："
            prop="carId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="editForm.carId"
              filterable
              placeholder="--选择型号--"
            >
              <el-option
                v-for="item in carModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="门店："
            prop="storeId"
            style="float: left; width: 50%"
          >
            <el-select
              filterable
              clearable
              remote
              :remote-method="getStoreList"
              v-model="editForm.storeId"
              placeholder="--选择门店--"
            >
              <el-option
                v-for="item in storeDataList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>

        <el-form-item class="ts">
          <el-form-item
            label="施工技师"
            prop="mechanicId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="editForm.mechanicId"
              filterable
              clearable
              placeholder="--选择技师--"
            >
              <el-option
                v-for="item in mechanicList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="施工日期："
            prop="buildAt"
            style="float: left; width: 50%"
          >
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="editForm.buildAt"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-form-item>

        <el-form-item label="产品类型：" prop="productId">
          <el-select
            disabled
            v-model="editForm.productId"
            placeholder="--选择产品类型--"
          >
            <el-option
              v-for="item in productIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <div
          v-for="(uPosition, uPoIndex) in editForm.productPositions"
          :key="uPoIndex"
        >
          <div style="margin: 30px 0 10px 0">质保部位{{ uPoIndex + 1 }}:</div>
          <el-form-item class="ts">
            <el-form-item label="产品系列">
              <el-select
                filterable
                clearable
                remote
                :remote-method="getProductModelList"
                @change="handleProductModel"
                @focus="handleProductFocusIndex(uPoIndex)"
                @blur="handleProductFocusIndex(uPoIndex)"
                v-model="uPosition.productModelId"
                placeholder="--选择产品系列--"
              >
                <el-option
                  v-for="item in uPosition.proModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品型号:">
              <el-select
                filterable
                clearable
                remote
                :remote-method="getProductTypeList"
                @change="handleProductType"
                @focus="handleProductFocusIndex(uPoIndex)"
                @blur="handleProductFocusIndex(uPoIndex)"
                v-model="uPosition.productTypeId"
                placeholder="--选择型号--"
              >
                <el-option
                  v-for="item in uPosition.productTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item class="ts">
            <el-form-item label="产品部位:">
              <el-select
                filterable
                clearable
                @change="productSelect"
                @focus="handleProductFocusIndex(uPoIndex)"
                @blur="handleProductFocusIndex(uPoIndex)"
                v-model="uPosition.productPositionId"
                placeholder="--选择部位--"
              >
                <div v-if="isWholeCar === false">
                  <el-option
                    v-for="item in uPosition.productPositionList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </div>
                <div v-else-if="isWholeCar === true">
                  <el-option label="整车" :value="Number(0)"></el-option>
                </div>
              </el-select>
            </el-form-item>

            <el-form-item label="膜卷号：">
              <el-select
                clearable
                filterable
                remote
                :remote-method="getRollList"
                @change="rollSelect"
                @focus="handleProductFocusIndex(uPoIndex)"
                @blur="handleProductFocusIndex(uPoIndex)"
                v-model="uPosition.rollId"
                placeholder="--选择膜卷号--"
              >
                <el-option
                  v-for="item in uPosition.rollList"
                  :key="item.id"
                  :label="item.rollNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button
              v-show="uPosition.status != 0"
              @click.prevent="editRemoveQualityParts(uPoIndex)"
              >删除</el-button
            >
            <el-button
              v-show="uPosition.status == 0"
              type="success"
              icon="el-icon-check"
            ></el-button>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editAddDomain">新增质保部位</el-button>
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加质保客户"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="100px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="客户名称：" prop="customerName">
          <el-input
            v-model.trim="newForm.customerName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="customerPhone">
          <el-input
            v-model.trim="newForm.customerPhone"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="价格：" prop="price">
          <el-input
            type="number"
            v-model.trim="newForm.price"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="车牌号：" prop="carNumber">
          <el-input
            v-model.trim="newForm.carNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item class="ts">
          <el-form-item
            label="车架号："
            prop="VIN"
            style="float: left; width: 50%"
          >
            <el-input v-model.trim="newForm.VIN" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="汽车颜色："
            prop="carColor"
            style="float: left; width: 50%"
          >
            <el-input
              v-model.trim="newForm.carColor"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item
            label="汽车型号："
            prop="carId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="newForm.carId"
              filterable
              placeholder="--选择型号--"
            >
              <el-option
                v-for="item in carModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="门店："
            prop="storeId"
            style="float: left; width: 50%"
          >
            <el-select
              filterable
              clearable
              remote
              :remote-method="getStoreList"
              v-model="newForm.storeId"
              placeholder="--选择门店--"
            >
              <el-option
                v-for="item in storeDataList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item
            label="施工技师"
            prop="mechanicId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="newForm.mechanicId"
              filterable
              clearable
              placeholder="--选择技师--"
            >
              <el-option
                v-for="item in mechanicList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="施工日期："
            prop="buildAt"
            style="float: left; width: 50%"
          >
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="newForm.buildAt"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-form-item>

        <el-form-item class="ts">
          <el-form-item label="产品类型：" prop="productId">
            <el-select
              clearable
              filterable
              remote
              :remote-method="getProductList"
              @change="handleGetProduct"
              v-model="newForm.productId"
              placeholder="--选择产品类型--"
            >
              <el-option
                v-for="item in productIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否整车：">
            <div style="vertical-align: middle">
              <el-switch
                v-model="isWholeCar"
                @change="handleIsWholeCar"
              ></el-switch>
            </div>
          </el-form-item>
        </el-form-item>

        <!-- 质保部位 -->

        <div
          v-for="(position, poIndex) in newForm.productPositions"
          :key="poIndex"
        >
          <div style="margin: 30px 0 10px 0">质保部位{{ poIndex + 1 }}:</div>
          <el-form-item class="ts">
            <el-form-item label="产品系列">
              <el-select
                filterable
                clearable
                remote
                :remote-method="getProductModelList"
                @change="handleProductModel"
                @focus="handleProductFocusIndex(poIndex)"
                @blur="handleProductFocusIndex(poIndex)"
                v-model="position.productModelId"
                placeholder="--选择产品系列--"
              >
                <el-option
                  v-for="item in position.proModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品型号:">
              <el-select
                filterable
                clearable
                remote
                :remote-method="getProductTypeList"
                @change="handleProductType"
                @focus="handleProductFocusIndex(poIndex)"
                @blur="handleProductFocusIndex(poIndex)"
                v-model="position.productTypeId"
                placeholder="--选择型号--"
              >
                <el-option
                  v-for="item in position.productTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item class="ts">
            <el-form-item label="产品部位:">
              <el-select
                filterable
                clearable
                @change="productSelect"
                @focus="handleProductFocusIndex(poIndex)"
                @blur="handleProductFocusIndex(poIndex)"
                v-model="position.productPositionId"
                placeholder="--选择部位--"
              >
                <div v-if="isWholeCar === false">
                  <el-option
                    v-for="item in position.productPositionList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </div>
                <div v-else-if="isWholeCar === true">
                  <el-option label="整车" :value="Number(0)"></el-option>
                </div>
              </el-select>
            </el-form-item>

            <el-form-item label="膜卷号：">
              <el-select
                clearable
                filterable
                remote
                :remote-method="getRollList"
                @change="rollSelect"
                @focus="handleProductFocusIndex(poIndex)"
                @blur="handleProductFocusIndex(poIndex)"
                v-model="position.rollId"
                placeholder="--选择膜卷号--"
              >
                <el-option
                  v-for="item in position.rollList"
                  :key="item.id"
                  :label="item.rollNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button @click.prevent="removeQualityParts(poIndex)"
              >删除</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <div style="color: red; text-align: center">
        注：同一质保部位只能质保一次
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addQualityParts" v-if="isWholeCar == false"
          >新增质保部位</el-button
        >
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getZBCP,
  carModel,
  getMD,
  getCP,
  getMJGL,
  getYYS,
  getCPLX,
  getCPJM,
  getJS,
} from "./../axios/api";
import moment from "dayjs";
import { writeFile } from "../utils/xlsx";
import areaData from "../utils/china-area.json";

export default {
  name: "Zbcp",
  data() {
    return {
      options: areaData, // 城市信息
      isEditPage: false, // 是否为修改页面
      mechanicList: [], // 技师
      productName: [], // 用于判断是否部位重复
      productModelIndex: null, // 选择得是第一个部位
      newProductPositions: [], // 获取的产品部位
      isWholeCar: true, // 是否显示整车质保
      carModelList: [], // 汽车型号
      storeDataList: [], // 门店
      productPositionList: [], // 产品部位
      productIdList: [], // 产品类型
      proModelList: [], // 产品系列
      productTypeList: [], // 产品型号
      rollList: [], // 膜卷
      partnerList: [], // 经销商
      statusList: [
        { id: 1, name: "待审核" },
        { id: 2, name: "已审核" },
        { id: 3, name: "已质保" },
      ],
      queryForm: {},
      editFormVisible: false, //编辑弹框
      editForm: {
        productId: null,
        productPositions: [],
      }, //编辑弹框数据
      newData: false, //添加弹框
      newForm: {
        productId: null,
        productPositions: [],
      }, //添加弹框数据
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      tableData: [],
      eTableData: [],
      eTabelLoading:false, //
      rules: {
        customerName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
        ],
        customerPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        carNumber: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
        ],
        VIN: [{ required: true, message: "请输入车架号", trigger: "blur" }],
        carColor: [
          { required: true, message: "请输入汽车颜色", trigger: "blur" },
        ],
        carId: [
          { required: true, message: "请选择汽车型号", trigger: "change" },
        ],
        storeId: [{ required: true, message: "请选择门店", trigger: "change" }],
        productId: [
          { required: true, message: "请选择产品类型", trigger: "change" },
        ],
        productModelId: [
          { required: true, message: "请选择系列", trigger: "change" },
        ],
        productTypeId: [
          { required: true, message: "请选择型号", trigger: "change" },
        ],
        buildAt: [{ required: true, message: "请选择日期", trigger: "change" }],
      },
    };
  },
  watch:{
    eTableData(newVal){
      // console.log(newVal.length,this.total)
      if (newVal.length === this.total) {
        this.exprotData()
      }
    }
  },
  methods: {
    exprotData() {
      // 获取导出数据
      // console.log(this.eTableData.length,this.total)
      if (this.eTableData.length === this.total) {
          // 
          this.eTabelLoading = false;
          this.$message({
            type: "success",
            message: "导出成功！",
          });
          // 
          const SheetHeader = [
          { key: "id", label: "编号" },
          { key: "code", label: "质保单号" },
          { key: "customerName", label: "客户名称" },
          // { key: "customerPhone", label: "手机号" },
          { key: "productName", label: "产品类型" },
          { key: "newProductPositions", label: "质保部位" },
          { key: "price", label: "价格" },
          { key: "carNumber", label: "车牌号" },
          { key: "VIN", label: "车架号" },
          { key: "carColor", label: "汽车颜色" },
          { key: "carName", label: "汽车型号" },
          { key: "storeName", label: "门店名称" },
          { key: "province", label: "省" },
          { key: "town", label: "市" },
          { key: "district", label: "区" },
          { key: "partnerName", label: "经销商" },
          { key: "buildAt", label: "施工时间" },
          {
            key: "status",
            label: "状态",
            render: (value) => ["", "待审核", "已审核", "已质保"][value],
          },
          { key: "createdAt", label: "创建时间" },
        ];
        writeFile(
          this.eTableData,
          SheetHeader,
          `质保客户数据${moment(new Date()).format("YYYY-MM-DD")}`
        );
      }
    },
   getTableData() {
      var that = this;
      that.eTabelLoading = true;
      this.$message({
        type: "warning",
        message: "正在导出请稍后！",
      });

      let data = {
        customerName: that.queryForm.customerName
          ? that.queryForm.customerName
          : undefined,
        customerPhone: that.queryForm.customerPhone
          ? that.queryForm.customerPhone
          : undefined,
        carNumber: that.queryForm.carNumber
          ? that.queryForm.carNumber
          : undefined,
        VIN: that.queryForm.VIN ? that.queryForm.VIN : undefined,
        code: that.queryForm.code ? that.queryForm.code : undefined,
        rollNumber: that.queryForm.rollNumber
          ? that.queryForm.rollNumber
          : undefined,
        storeId: that.queryForm.storeId ? that.queryForm.storeId : undefined,
        mechanicId: that.queryForm.mechanicId
          ? that.queryForm.mechanicId
          : undefined,
        partnerId: that.queryForm.partnerId
          ? that.queryForm.partnerId
          : undefined,
        status: that.queryForm.status ? that.queryForm.status : undefined,
        startAt: that.queryForm.startAt
          ? Number(new Date(that.queryForm.startAt)) / 1000
          : undefined,
        endAt: that.queryForm.endAt
          ? Number(new Date(that.queryForm.endAt)) / 1000
          : undefined,
        pageSize: that.total || 99999, //99999
        pageNumber: 1,
      };
      // 请求
     getZBCP.getTable(data).then(async function (res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list } = res.data;
          // 一次请求多少
          let i = 0;
          const newFiles = list.reduce((p, n) => {
            p[i] = p[i] || [];
            p[i].push(n);
            if (p[i].length === 50) {
              i++;
            }
            return p;
          }, []);
          // console.log(newFiles)
          // 
          for(let element of newFiles){
            await  Promise.all(
              element.map(async(lis)=>{return await  that.getZBDetails(lis.id)})
          ).then(function (res) {
              // 
              that.eTableData = [...that.eTableData,...res]

           }).catch(function (err) {})
          }
         
        }
      });

    },
    // 获取单个数据详情
   getZBDetails(id){
      return  getZBCP.getTabelId(id).then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const data = res.data;
            data.createdAt = moment(new Date(data.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );
            data.buildAt = moment(new Date(data.buildAt * 1000)).format(
              "YYYY-MM-DD"
            );

            // 价格
            data.price = parseFloat((data.price / 100).toFixed(2));

            // 质保部位
            data.newProductPositions =  data.productPositions.map((p) => {

              p.contentData = "【 产品系列:" + p.productModelName + ", 产品型号：" + p.productTypeName + ", 产品部位：" + p.productPositionName + ", 膜卷号："+p.rollNumber + " 】"

              return p.contentData
            }).toString();

            return data
          }
        })

    },
    // 
    handleIsWholeCar(value) {
      let that = this;
      that.isWholeCar = value;
      that.newForm.productPositions = [
        {
          proModelList: that.proModelList,
          productPositionId: null,
          productTypeId: null,
          rollId: null,
        },
      ];
    },
    // 根据产品类型获取系列
    handleGetProduct(value) {
      let that = this;
      // console.log(value);
      // 根据产品类型生成几个部位
      let proPosition = [];
      that.productIdList.map((pro) => {
        if (value == pro.id) {
          proPosition = pro.position;
        }
      });
      that.newProductPositions = proPosition;

      //获取系列列表
      that.getProductModelList();
    },

    // get
    getProductModelList(query) {
      let that = this;
      if (that.newForm.productId || that.editForm.productId) {
        getCPJM
          .getWFTable({
            pageSize: 1000,
            pageNumber: 1,
            productId: that.newForm.productId || that.editForm.productId,
            name: query || undefined,
          })
          .then(function (res) {
            // console.log(res);
            if (res.code !== 0) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            } else {
              const { list } = res.data;
              console.log(list);
              that.proModelList = list;

              // 生成质保
              that.newForm.productPositions = [
                {
                  proModelList: list,
                  productPositionId: null,
                  productTypeId: null,
                  rollId: null,
                },
              ];
              that.editForm.productPositions = [
                {
                  proModelList: list,
                  productPositionId: null,
                  productTypeId: null,
                  rollId: null,
                },
              ];
              that.isWholeCar = true;
              that.$forceUpdate();
            }
          });
      }
    },

    // 失焦，聚焦时获取质保第几个部位下标
    handleProductFocusIndex(index) {
      let that = this;
      that.productModelIndex = index;
    },

    // 选择系列时
    handleProductModel(value) {
      let that = this;
      // 根据系列获取型号
      that.getProductTypeList();

      // 根据系列获取膜卷号
      that.getRollList();
    },

    getProductTypeList(query) {
      let that = this;
      let newProductPositions =
        (that.newForm.productPositions &&
          that.newForm.productPositions.length &&
          that.newForm.productPositions[that.productModelIndex]) ||
        undefined;

      let edtProductPositions =
        (that.editForm.productPositions &&
          that.editForm.productPositions.length &&
          that.editForm.productPositions[that.productModelIndex]) ||
        undefined;
      console.log(edtProductPositions);
      getCP
        .getTable({
          productModelId: newProductPositions
            ? that.newForm.productPositions[that.productModelIndex]
                .productModelId
            : undefined || edtProductPositions
            ? that.editForm.productPositions[that.productModelIndex]
                .productModelId
            : undefined,
          pageSize: 1000,
          pageNumber: 1,
          name: query || undefined,
        })
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            // 获取型号
            if (that.isEditPage) {
              that.editForm.productPositions[
                that.productModelIndex
              ].productTypeList = [];
              that.editForm.productPositions[
                that.productModelIndex
              ].productTypeList = list;

              // 清空选择系列之后改变的数据
              that.editForm.productPositions[
                that.productModelIndex
              ].productTypeId = null;
            } else {
              that.newForm.productPositions[
                that.productModelIndex
              ].productTypeList = [];
              that.newForm.productPositions[
                that.productModelIndex
              ].productTypeList = list;

              // 清空选择系列之后改变的数据
              that.newForm.productPositions[
                that.productModelIndex
              ].productTypeId = null;
            }

            that.$forceUpdate();
          }
        });
    },


    // 选择型号时获取对应型号下的部位

    handleProductType(value) {
      console.log(value);
      let that = this;
      // 获取型号下面绑定部位获取部位id

      if (that.isEditPage) {
        that.editForm.productPositions[
          that.productModelIndex
        ].productTypeList.map((type) => {
          if (type.id === value) {
            that.editForm.productPositions[
              that.productModelIndex
            ].productPositionList = type.productPosition;
          }
        });
      } else {
        that.newForm.productPositions[
          that.productModelIndex
        ].productTypeList.map((type) => {
          if (type.id === value) {
            that.newForm.productPositions[
              that.productModelIndex
            ].productPositionList = type.productPosition;
          }
        });
      }

      // 根据系列获取膜卷号
      that.getRollList();

      that.$forceUpdate();
    },

    getRollList(query) {
      let that = this;
      let newProductPositions =
        (that.newForm.productPositions &&
          that.newForm.productPositions.length &&
          that.newForm.productPositions[that.productModelIndex]) ||
        undefined;
      getMJGL
        .getTable({
          pageSize: 15,
          pageNumber: 1,
          productModelId: newProductPositions
            ? that.newForm.productPositions[that.productModelIndex]
                .productModelId
            : undefined ||
              that.editForm.productPositions[that.productModelIndex]
            ? that.editForm.productPositions[that.productModelIndex]
                .productModelId
            : undefined,
            productTypeId: newProductPositions
            ? that.newForm.productPositions[that.productModelIndex]
                .productTypeId
            : undefined ||
              that.editForm.productPositions[that.productModelIndex]
            ? that.editForm.productPositions[that.productModelIndex]
                .productTypeId
            : undefined,
          rollNumber: query || undefined,
          status:1
        })
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;

            // 如果膜卷系数小于等于0 就不显示
            let newList = [];
            list.map((lis) => {
              if (lis.warrantyCount - lis.useWarrantyCount > 0) {
                newList.push(lis);
              }
            });
            // console.log('????',newList);

            // 获取膜卷
            if (that.isEditPage) {
              that.editForm.productPositions[that.productModelIndex].rollList =
                [];
              that.editForm.productPositions[that.productModelIndex].rollList =
                newList;

              // 清空选择系列之后改变的数据
              that.editForm.productPositions[that.productModelIndex].rollId =
                null;
            } else {
              that.newForm.productPositions[that.productModelIndex].rollList =
                [];
              that.newForm.productPositions[that.productModelIndex].rollList =
                newList;

              // 清空选择系列之后改变的数据
              that.newForm.productPositions[that.productModelIndex].rollId =
                null;
            }
            that.$forceUpdate();
          }
        })
        .catch(function (res) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    // 选择产品部位变化时
    productSelect(value) {
      let that = this;
      that.$forceUpdate();
    },
    // 选择膜卷时
    rollSelect(value) {
      this.$forceUpdate();
    },

    // 点击新增质保部位
    addQualityParts() {
      let that = this;

      if (
        that.newForm.productPositions.length >= that.newProductPositions.length
      ) {
        that.$message({
          type: "warning",
          message: "质保部位已上限！",
        });
      } else {
        that.newForm.productPositions.push({
          proModelList: that.proModelList,
          productPositionId: null,
          productTypeId: null,
          rollId: null,
        });
      }
      that.$forceUpdate();
    },
    // 删除质保部位
    removeQualityParts(index) {
      this.newForm.productPositions.splice(index, 1);
      this.$forceUpdate();
    },

    // 编辑时点击新增质保部位
    editAddDomain() {
      let that = this;

      that.productIdList.map((pro) => {
        if (pro.id === that.editForm.productId) {
          if (that.editForm.productPositions.length >= pro.position.length) {
            that.$message({
              type: "warning",
              message: "质保部位已上限！",
            });
          } else {
            that.editForm.productPositions.push({
              proModelList: that.proModelList,
              productPositionId: null,
              productTypeId: null,
              rollId: null,
            });
          }
          that.$forceUpdate();
        }
      });
    },
    // 编辑时删除质保部位
    editRemoveQualityParts(index) {
      let that = this;

      that.editForm.productPositions.map((pro, proIndex) => {
        console.log(pro.id);
        if (pro.id) {
          that.editForm.productPositions[index].status = 0;
        } else {
          that.editForm.productPositions.splice(proIndex, 1);
        }
      });

      that.$forceUpdate();
    },

    // 获取产品类型
    getProductList(query) {
      let that = this;
      // 产品类型
      getCPLX
        .getTable({
          pageNumber: 1,
          pageSize: 1000,
          name: query || undefined,
        })
        .then(function (res) {
          // console.log(res)
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            // console.log(list);
            that.productIdList = list;
          }
        });
    },

    // 门店
    getStoreList(query) {
      let that = this;
      let storeData = {
        pageSize: 1000,
        pageNumber: 1,
        name: query || undefined,
      };
      getMD
        .getTable(storeData)
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            that.storeDataList = list;
          }
        })
        .catch(function (res) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    // 经销商
    getPartnerList(query) {
      let that = this;
      let partnerData = {
        pageNumber: 1,
        pageSize: 1000,
        name: query,
      };
      if (query !== "") {
        getYYS.getTable(partnerData).then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            let { list } = res.data;

            that.partnerList = list;
          }
        });
      } else {
        that.partnerList = [];
      }
      // console.log(data)
    },

    //  获取汽车型号，门店，产品类型，卷膜号 , 供应商
    onload() {
      let that = this;
      // 产品类型
      that.getProductList();
      // 门店
      that.getStoreList();
      // 经销商
      that.getPartnerList();

      // 获取技师
      getJS
        .getTable({
          pageNumber: 1,
          pageSize: 1000,
        })
        .then(function (res) {
          // console.log(res)
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            // console.log(list);
            that.mechanicList = list;
          }
        });

      // 汽车型号
      let carData = {
        pageSize: 1000,
        pageNumber: 1,
      };
      carModel
        .getTable(carData)
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            that.carModelList = list;
          }
        })
        .catch(function (res) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        });

      //获取经销商列表
    },

    //搜索
    search: function () {
      var that = this;
      that.loading = true;
      that.currentPage = 1;
      that.init();
    },
    reset: function () {
      this.queryForm = {};
      this.currentPage = 1;
      this.init();
    },

    add: function () {
      this.newData = true; //显示弹框

      this.onload(); // 获取型号，门店，部位，膜卷
      this.handleGetProduct();
      // this.getProductModelList();
      // this.handleProductModel()
    },
    //点击关闭dialog
    newClose(done) {
      let that = this;
      that.$refs["newForm"].resetFields();
      that.newData = false;
      that.newForm = {};

      that.onload(); // 获取型号，门店，部位，膜卷
      that.handleGetProduct();
      // that.getProductModelList();
      // that.handleProductModel()
    },
    //点击取消
    newCancel(formName) {
      let that = this;
      that.$refs["newForm"].resetFields();
      that.newData = false;
      that.newForm = {};

      that.onload(); // 获取型号，门店，部位，膜卷

      that.handleGetProduct();
      // that.getProductModelList();
      // that.handleProductModel();
    },
    //点击添加
    newUpdate(forName) {
      var that = this;
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          let productPositions = [];
          let isPass = true;
          that.newForm.productPositions.map((pro, index) => {
            // 把选择得部位名字添加进来
            if (pro.productPositionList) {
              pro.productPositionList.map((proItem) => {
                if (pro.productPositionId == proItem.id) {
                  pro.productPositionName = proItem.name;
                }
              });
            }

            let productPositionsObj = {};
            if (
              pro.productPositionId ||
              pro.rollId ||
              pro.productTypeId ||
              pro.productModelId
            ) {
              if (!pro.productModelId) {
                that.$message({
                  type: "warning",
                  message: "质保系列不能为空",
                });
                isPass = false;
              } else if (
                pro.productPositionId !== 0 &&
                !pro.productPositionId
              ) {
                that.$message({
                  type: "warning",
                  message: "质保部位不能为空",
                });
                isPass = false;
              } else if (!pro.rollId) {
                that.$message({
                  type: "warning",
                  message: "膜卷号不能为空",
                });
                isPass = false;
              } else if (!pro.productTypeId) {
                that.$message({
                  type: "warning",
                  message: "质保型号不能为空",
                });
                isPass = false;
              }
              productPositionsObj.productPositionId = pro.productPositionId;
              productPositionsObj.productTypeId = pro.productTypeId;
              productPositionsObj.rollId = pro.rollId;
              productPositions.push(productPositionsObj);
            } else {
              that.newForm.productPositions.splice(index);
            }
          });

          // 判断是否有重复部位
          let newArr = that.newForm.productPositions.map(
            (item) => item.productPositionName
          );
          // Set类似于数组，区别在于它所有的成员都是唯一的，不能有重复的，会将重复的值去重
          let arrSet = new Set(newArr);
          // 判断set之后的数组的长度跟set之前的数组是否相等
          if (arrSet.size !== newArr.length) {
            that.$message({
              type: "warning",
              message: "产品部位重复!",
            });
          } else {
            if (productPositions.length === 0 || isPass == false) {
              if (productPositions.length === 0) {
                that.$message({
                  type: "warning",
                  message: "至少质保一个部位!",
                });
              }
            } else {
              let data = {
                customerName: that.newForm.customerName,
                customerPhone: that.newForm.customerPhone,
                carNumber: that.newForm.carNumber,
                VIN: that.newForm.VIN,
                carColor: that.newForm.carColor,
                carId: that.newForm.carId,
                storeId: that.newForm.storeId,
                buildAt: Number(new Date(that.newForm.buildAt)) / 1000,
                mechanicId: that.newForm.mechanicId,
                productId: that.newForm.productId,
                productPositions: productPositions,
                price: parseFloat((that.newForm.price * 100).toFixed(2)) || 0,
              };

              //这里再向后台发个post请求重新渲染表格数据
              console.log(data);
              // return;
              getZBCP
                .addTable(JSON.stringify(data))
                .then(function (res) {
                  if (res.code !== 0) {
                    that.$alert(res.message + "!", "提示", {
                      confirmButtonText: "确定",
                    });
                  } else {
                    that.$message({
                      type: "success",
                      message: "添加成功!",
                    });
                    that.$refs["newForm"].clearValidate();
                    that.newForm = {};
                    // that.newForm.productPositions = [
                    //   { productPositionId: null, rollId: null }
                    // ];
                    that.newData = false;
                    // that.currentPage = 1;
                    that.init();
                  }
                })
                .catch(function (res) {
                  //清空
                  that.$refs["newForm"].clearValidate();
                  that.newForm = {};
                  that.newForm.productPositions = [
                    { productPositionId: null, rollId: null },
                  ];

                  that.newData = false;
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    current_change: function (currentPage) {
      // console.log(currentPage)
      var that = this;
      this.currentPage = currentPage;
      this.init();
    },
    //点击编辑
    bj: function (index, row) {
      console.log(row);
      var that = this;

      //  获取单个详情
      getZBCP.getTabelId(row.id).then(function (res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const data = res.data;

          // 价格
          data.price = parseFloat(data.price / 100);
          // 时间
          data.buildAt = moment(new Date(data.buildAt * 1000)).format(
            "YYYY-MM-DD"
          );

          that.editForm = data;

          // 产品类型
          that.productIdList = [
            {
              id: data.productId,
              name: data.productName,
            },
          ];
          // 根据系列获取型号和部位
          that.editForm.productPositions = data.productPositions.map((pro) => {
            // 系列
            if (data.productId) {
              getCPJM
                .getWFTable({
                  pageSize: 1000,
                  pageNumber: 1,
                  productId: data.productId,
                })
                .then(function (res) {
                  // console.log(res);
                  if (res.code !== 0) {
                    that.$alert(res.message + "!", "提示", {
                      confirmButtonText: "确定",
                    });
                  } else {
                    const { list } = res.data;
                    // console.log(list);
                    pro.proModelList = list;
                    that.$forceUpdate();
                  }
                });
            }

            // 型号
            if (pro.productModelId) {
              getCP
                .getTable({
                  pageSize: 1000,
                  pageNumber: 1,
                  productModelId: pro.productModelId,
                })
                .then(function (res) {
                  // console.log(res);
                  if (res.code !== 0) {
                    that.$alert(res.message + "!", "提示", {
                      confirmButtonText: "确定",
                    });
                  } else {
                    const { list } = res.data;
                    // console.log(list);
                    pro.productTypeList = list;
                    that.$forceUpdate();
                  }
                });
            }

            // 部位
            // 根据信号id获取部位
            getZBCP.getPositionId(pro.productTypeId).then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                const { productPosition } = res.data;
                pro.productPositionList = productPosition;
                that.$forceUpdate();
              }
            });

            // 膜卷
            pro.rollList = [
              {
                id: pro.rollId,
                rollNumber: pro.rollNumber,
              },
            ];

            that.$forceUpdate();

            return pro;
          });
        }
      });

      //
      that.isEditPage = true; // 判断是否为修改页面
      that.isWholeCar = false;
      this.editFormVisible = true; //显示弹框

      // 门店
      that.getStoreList();
    },
    // 审核质保
    sh: function (index, row) {
      let data = {
        warrantyId: row.id,
      };
      var that = this;
      this.$confirm("确定发起审核？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          getZBCP
            .initiatePass(JSON.stringify(data))
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
                that.currentPage = 1;
              } else {
                // that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "审核成功!",
                });
              }
            })
            .catch(function (res) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 发起质保
    zb: function (index, row) {
      // console.log(row)
      let data = {
        warrantyId: row.id,
        productPositionId: row.productPositions[0].productPositionId,
        rollId: row.productPositions[0].rollId,
      };
      var that = this;
      this.$confirm("确定发起质保？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          // console.log(data)
          // return
          getZBCP
            .initiateQuality(JSON.stringify(data))
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
                that.currentPage = 1;
              } else {
                // that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "质保成功!",
                });
              }
            })
            .catch(function (res) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;
      this.editForm = {};
      this.editForm.productPositions = [
        { productPositionId: null, productTypeId: null, rollId: null },
      ];

      this.init();

      this.handleGetProduct();
      // this.getProductModelList();
      // this.handleProductModel();
    },
    //点击取消
    handleCancel(formName) {
      this.editFormVisible = false;
      this.editForm = {};
      this.editForm.productPositions = [
        { productPositionId: null, productTypeId: null, rollId: null },
      ];
      this.init();

      this.handleGetProduct();
      // this.getProductModelList();
      // this.handleProductModel();
    },
    //点击更新
    handleUpdate(forName) {
      var that = this;
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          //更新的时候就把弹出来的表单中的数据写到要修改的表格中
          let productPositions = [];
          let isPass = true;
          that.editForm.productPositions.map((pro, index) => {
            // 把选择得部位名字添加进来
            if (pro.productPositionList) {
              pro.productPositionList.map((proItem) => {
                if (pro.productPositionId == proItem.id) {
                  pro.productPositionName = proItem.name;
                }
              });
            }

            let productPositionsObj = {};
            if (
              pro.productPositionId ||
              pro.rollId ||
              pro.productTypeId ||
              pro.productModelId
            ) {
              if (!pro.productModelId) {
                that.$message({
                  type: "warning",
                  message: "质保系列不能为空",
                });
                isPass = false;
              } else if (
                pro.productPositionId !== 0 &&
                !pro.productPositionId
              ) {
                that.$message({
                  type: "warning",
                  message: "质保部位不能为空",
                });
                isPass = false;
              } else if (!pro.rollId) {
                that.$message({
                  type: "warning",
                  message: "膜卷号不能为空",
                });
                isPass = false;
              } else if (!pro.productTypeId) {
                that.$message({
                  type: "warning",
                  message: "质保型号不能为空",
                });
                isPass = false;
              }
              productPositionsObj.id = pro.id;
              productPositionsObj.status = pro.status;
              productPositionsObj.productPositionId = pro.productPositionId;
              productPositionsObj.productTypeId = pro.productTypeId;
              productPositionsObj.rollId = pro.rollId;
              productPositions.push(productPositionsObj);

              if (productPositionsObj.id == undefined) {
                delete productPositionsObj.id;
                delete productPositionsObj.status;
              }
              if (productPositionsObj.status == undefined) {
                delete productPositionsObj.status;
              }
            } else {
              that.editForm.productPositions.splice(index);
            }
          });

          // 判断是否有重复部位
          let newArr = that.editForm.productPositions.map(
            (item) => item.productPositionName
          );
          // Set类似于数组，区别在于它所有的成员都是唯一的，不能有重复的，会将重复的值去重
          let arrSet = new Set(newArr);
          // 判断set之后的数组的长度跟set之前的数组是否相等
          if (arrSet.size !== newArr.length) {
            that.$message({
              type: "warning",
              message: "产品部位重复!",
            });
          } else {
            if (productPositions.length === 0 || isPass == false) {
              if (productPositions.length === 0) {
                that.$message({
                  type: "warning",
                  message: "至少质保一个部位!",
                });
              }
            } else {
              var data = {
                customerName: that.editForm.customerName,
                customerPhone: that.editForm.customerPhone,
                carNumber: that.editForm.carNumber,
                VIN: that.editForm.VIN,
                carColor: that.editForm.carColor,
                carId: that.editForm.carId,
                storeId: that.editForm.storeId,
                buildAt: Number(new Date(that.editForm.buildAt)) / 1000,
                mechanicId: that.editForm.mechanicId,
                productId: that.editForm.productId,
                productPositions: productPositions,
                price: parseFloat((that.editForm.price * 100).toFixed(2)) || 0,
              };
              // console.log(data);
              // return;
              getZBCP
                .editTable(data, that.editForm.id)
                .then(function (res) {
                  if (res.code !== 0) {
                    that.$alert(res.message, "提示", {
                      confirmButtonText: "确定",
                    });
                  } else {
                    that.$message({
                      type: "success",
                      message: "更新成功!",
                    });
                    that.editFormVisible = false;
                    that.$refs["editForm"].resetFields();
                    that.editForm = {};
                    that.init();
                  }
                })
                .catch(function (res) {
                  that.editFormVisible = false;
                  // console.log(res)
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //点击删除
    sc: function (index, row) {
      var that = this;
      // console.log(row)
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getZBCP
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
              // that.currentPage = 1;
              that.init();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    init: function () {
      var that = this;
      that.loading = true;
      let data = {
        customerName: that.queryForm.customerName
          ? that.queryForm.customerName
          : undefined,
        customerPhone: that.queryForm.customerPhone
          ? that.queryForm.customerPhone
          : undefined,
        carNumber: that.queryForm.carNumber
          ? that.queryForm.carNumber
          : undefined,
        VIN: that.queryForm.VIN ? that.queryForm.VIN : undefined,
        code: that.queryForm.code ? that.queryForm.code : undefined,
        rollNumber: that.queryForm.rollNumber
          ? that.queryForm.rollNumber
          : undefined,
        storeId: that.queryForm.storeId ? that.queryForm.storeId : undefined,
        mechanicId: that.queryForm.mechanicId
          ? that.queryForm.mechanicId
          : undefined,
        partnerId: that.queryForm.partnerId
          ? that.queryForm.partnerId
          : undefined,
        status: that.queryForm.status ? that.queryForm.status : undefined,
        startAt: that.queryForm.startAt
          ? Number(new Date(that.queryForm.startAt)) / 1000
          : undefined,
        endAt: that.queryForm.endAt
          ? Number(new Date(that.queryForm.endAt)) / 1000
          : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };

      // return
      getZBCP.getTable(data).then(function (res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list, totalNumber } = res.data;

          list.map((lis) => {
            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );
            lis.buildAt = moment(new Date(lis.buildAt * 1000)).format(
              "YYYY-MM-DD"
            );

            lis.price = parseFloat((lis.price / 100).toFixed(2));
          });

          that.total = totalNumber;
          that.tableData = list;
          that.loading = false;
          that.isEditPage = false;
        }
      });

      that.onload(); // 获取型号，门店，部位，膜卷
    },
  },
  mounted() {
    var that = this;
    that.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.demo-table-expand {
  font-size: 0;
  margin-left: 20px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 40px;
  /* margin-right: 0;
  margin-bottom: 0; */
  /* width: 50%; */
}
</style>



// WEBPACK FOOTER //
// src/page/Zbcp.vue